import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { FormatDatasetV2 } from 'app/model/dataset/dataset.v2';
import { Location } from 'app/model/dataset/location/location';
import { Owned } from 'shell-models-lib';
import { BaseAdapter } from 'app/model/adapters/base.adapter';

export class GenericLocationAdapter extends BaseAdapter<Location, Model.DatasetLocation> {
    protected _toResource(location: Location): Model.CopySource {
        const locationType = Metamodel.modelOf(location).name;
        const result: Model.CopySource = {
            type: locationType
        };
        return result;
    }

    protected _toModel(location: Model.DatasetLocation, dataset: FormatDatasetV2): Location {
        const model = Metamodel.modelByName(location.type);
        const result = Owned.create<Location>(model, dataset);
        return result;
    }
}
